define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.showAiAgent = exports.closeAiAgent = exports.openAiAgent = exports.loadAiAgent = void 0;
    let aiAgentInitialized = false;
    const loadAiAgent = (agentConfig) => {
        if (aiAgentInitialized)
            return;
        aiAgentInitialized = true;
        const script = document.createElement("script");
        script.src = new URL("/oalasx/pub/aibots/ui/superagent/oalai-widget.js", agentConfig.host).toString();
        script.defer = true;
        const iframeUrl = new URL("/oalasx/pub/aibots/ui/superagent/", agentConfig.host);
        iframeUrl.searchParams.set("route", "ai-widget");
        if (agentConfig.channelId) {
            iframeUrl.searchParams.set("channel", agentConfig.channelId);
        }
        script.dataset.iframeSrc = iframeUrl.toString();
        script.dataset.template = "push-drawer";
        script.dataset.zindex = "1";
        if (agentConfig.suggestedPrompts.length > 0) {
            script.dataset.suggestedPrompts = JSON.stringify(agentConfig.suggestedPrompts);
        }
        script.dataset.size = JSON.stringify({
            width: agentConfig.width || "400px",
            height: "400px",
            maxHeight: "90vh"
        });
        const setOptionalDatasetValue = (key, value) => {
            if (value !== undefined) {
                script.dataset[key] = String(value);
            }
        };
        setOptionalDatasetValue("welcomeMessage", agentConfig.welcomeMessage);
        setOptionalDatasetValue("drawerTitle", agentConfig.drawerTitle);
        setOptionalDatasetValue("hideDrawerSubtitle", agentConfig.hideDrawerSubtitle);
        setOptionalDatasetValue("hideDisclaimer", agentConfig.hideDisclaimer);
        document.body.appendChild(script);
    };
    exports.loadAiAgent = loadAiAgent;
    const openAiAgent = () => {
        window.OALAIWidget.open();
    };
    exports.openAiAgent = openAiAgent;
    const closeAiAgent = () => {
        var _a, _b;
        (_b = (_a = window.OALAIWidget) === null || _a === void 0 ? void 0 : _a.close) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    exports.closeAiAgent = closeAiAgent;
    const showAiAgent = (show) => {
        const styleTagId = "agent-launcher-control";
        const styleTag = document.getElementById(styleTagId);
        if (styleTag) {
            styleTag.remove();
        }
        if (!show) {
            const style = document.createElement("style");
            style.id = styleTagId;
            style.textContent = `
      button[aria-label="Open Oracle AI Assistant"] {
        display: none !important;
      }
    `;
            document.head.appendChild(style);
        }
    };
    exports.showAiAgent = showAiAgent;
});
